<script lang="ts">
  import { getFormField } from 'formsnap'
  import type { Checkbox as CheckboxPrimitive } from 'bits-ui'
  import { Checkbox } from '$lib/components/ui/checkbox'
  type $$Props = CheckboxPrimitive.Props & { height?: string; width?: string }
  type $$Events = CheckboxPrimitive.Events

  export let onCheckedChange: $$Props['onCheckedChange'] = undefined
  export let height: string = ''
  export let width: string = ''

  const { name, setValue, attrStore, value } = getFormField()
  const { name: nameAttr, value: valueAttr, ...rest } = $attrStore
</script>

<Checkbox
  {...rest}
  {height}
  {width}
  checked={typeof $value === 'boolean' ? $value : false}
  onCheckedChange={(v) => {
    onCheckedChange?.(v)
    setValue(v)
  }}
  on:keydown
  {...$$restProps}
	on:click
/>
<input hidden {name} value={$value} />
